import "UI/Widget/Base";
import "UI/Plugin/Base";
import "UI/UI";
import "Html.js";
NS("UI");

UI.Module = true;
